export const OrderChangeDiet = (json: IOrderChangeDietResponse): IOrderChangeDietResponseModel => {
	const fromJSON = (orderChangeDiet: IOrderChangeDietResponse) => {
		const { cart_uuid, price_to_pay, price_to_refund, new_price_per_day, client_diet_days, ...rest } =
			orderChangeDiet
		return {
			cartUUID: cart_uuid,
			priceToPay: price_to_pay,
			priceToRefund: price_to_refund,
			newPricePerDay: new_price_per_day,
			clientDietDays: client_diet_days,
			...rest,
		}
	}
	return { ...fromJSON(json) }
}

export const OrderConfirmChangeDiet = (json: IOrderConfirmChangeDietResponse): IOrderConfirmChangeDietResponseModel => {
	const fromJSON = (orderConfirmChangeDiet: IOrderConfirmChangeDietResponse) => {
		const { cart_uuid, price_to_pay, price_to_refund, ...rest } = orderConfirmChangeDiet
		return {
			cartUUID: cart_uuid,
			priceToPay: price_to_pay,
			priceToRefund: price_to_refund,
			...rest,
		}
	}
	return { ...fromJSON(json) }
}
